import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useResetDefaultFilterShutdowns from '../mutations/useResetDefaultFilterShutdowns';
import {
  resetShutdownFilterValues,
  setChosenShutdownFilter,
} from '../containers/Shutdowns/features/filterNew/model/actions';

const useResetShutdownsFilter = () => {
  const dispatch = useDispatch();

  const { resetFilter } = useResetDefaultFilterShutdowns();

  const chosenFilterId = useSelector(
    (state) => state.filterShutdownStore.chosenFilterId
  );

  const reset = useCallback(async () => {
    await resetFilter(chosenFilterId);
    dispatch(resetShutdownFilterValues());
    dispatch(setChosenShutdownFilter({ id: null, name: null }));
  }, [dispatch, chosenFilterId]);

  return reset;
};

export default useResetShutdownsFilter;
